export default function Users(props: JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) {
	return (
		<svg
			width="36"
			height="36"
			viewBox="0 0 36 36"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M23.875 31.2188V28.2812C23.875 26.7231 23.256 25.2288 22.1543 24.127C21.0525 23.0252 19.5581 22.4062 18 22.4062H9.1875C7.62935 22.4062 6.13502 23.0252 5.03325 24.127C3.93147 25.2288 3.3125 26.7231 3.3125 28.2812V31.2188"
				stroke="currentColor"
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M7.71875 10.6563C7.71875 12.2144 8.33772 13.7087 9.4395 14.8105C10.5413 15.9123 12.0356 16.5313 13.5938 16.5313C15.1519 16.5313 16.6462 15.9123 17.748 14.8105C18.8498 13.7087 19.4688 12.2144 19.4688 10.6563C19.4688 9.0981 18.8498 7.60377 17.748 6.502C16.6462 5.40022 15.1519 4.78125 13.5938 4.78125C12.0356 4.78125 10.5413 5.40022 9.4395 6.502C8.33772 7.60377 7.71875 9.0981 7.71875 10.6563Z"
				stroke="currentColor"
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M32.6875 31.2187V28.2812C32.6865 26.9795 32.2533 25.715 31.4558 24.6862C30.6582 23.6574 29.5416 22.9226 28.2812 22.5972"
				stroke="currentColor"
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M23.875 4.97217C25.1387 5.29574 26.2588 6.0307 27.0587 7.06119C27.8586 8.09167 28.2928 9.35907 28.2928 10.6636C28.2928 11.9681 27.8586 13.2355 27.0587 14.266C26.2588 15.2965 25.1387 16.0314 23.875 16.355"
				stroke="currentColor"
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	)
}
